import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterBuilder, FilterComponent, FilterOperator} from "@core/shared/models/filter";
import {FilterCollectionField} from "@core/shared/models/filter/filter-collection";
import {ArrayFilterField} from "@core/shared/models/filter/array-filter-field";
import {Observable} from "rxjs";
import {SelectGroupConfiguration} from "@core/components/select/select-group/select-group.component";

@Component({
    selector: 'app-core-select-group-array-multiple-filter',
    templateUrl: './select-group-array-multiple-filter.component.html',
    styleUrl: './select-group-array-multiple-filter.component.scss',
    standalone: false
})
export class SelectGroupArrayMultipleFilterComponent<Option> implements OnInit, FilterComponent {

    @Input() builder: FilterBuilder;

    @Input() configuration: Partial<SelectGroupConfiguration<Option>>;

    @Input() sourceCallback: () => Observable<Option[]>;

    @Input() key: string;

    @Input() operator: FilterOperator;

    @Input() disableAutoSubmit: boolean;

    @Output() selectionChanged: EventEmitter<unknown[]> = new EventEmitter<unknown[]>();

    public values: Option[] = [];

    public filterCollectionField: FilterCollectionField;

    constructor() {

    }

    ngOnInit(): void {

        this.filterCollectionField = new FilterCollectionField(this.key);

        this.builder.addField(this.filterCollectionField);

        this.sourceCallback().subscribe((options: Option[]): void => {

            const choices: Option[] = options;

            options.forEach((option: Option): void => {

                choices.push(...this.configuration.retrieveChildOptionsFromParentCallback(option));
            });

            this.filterCollectionField.choices = choices;
        });

        Object.assign(this.configuration, {
             valuesCallback: () => {

                 return this.values;
             },
             selectedCallback: (option: Option): boolean => {

                const items: Option[] = [...this.values];

                return items.some((item: Option): boolean => {

                    return this.configuration.identifyOptionCallback(item) === this.configuration.identifyOptionCallback(option);
                });
            },
            handleSelectionCallback: (option: Option, selected: boolean): void => {

                const items: Option[] = [...this.values];

                if(selected){

                    items.push(option);
                }
                else{

                    const index: number = items.findIndex((item: Option): boolean => {

                        return this.configuration.identifyOptionCallback(item) === this.configuration.identifyOptionCallback(option);
                    });

                    items.splice(index, 1);
                }

                this.values = items;
            },
        } as Partial<SelectGroupConfiguration<Option>>);
    }

    public hydrateValue(): void {

        this.filterCollectionField.clear();

        this.values.forEach((value: Option): void => {

            this.filterCollectionField.fields.push(new ArrayFilterField(this.key, this.operator, this.configuration.fieldValueCallback(value)));
        });
    }

    public filter(): void {

        this.hydrateValue();

        this.selectionChanged.emit(this.values.map((item: Option): unknown => {

            return this.configuration.identifyOptionCallback(item);
        }));

        if (this.disableAutoSubmit) {

            return;
        }

        this.builder.filter();
    }

    public reset(): void {

        this.values = [];

        this.filterCollectionField.clear();
    }
}
